var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"order-summary__block"},[_c('div',{staticClass:"order-summary__block__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"order-summary__block__item"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }